import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a282da3e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=a282da3e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a282da3e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\projects\\web_h5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a282da3e')) {
      api.createRecord('a282da3e', component.options)
    } else {
      api.reload('a282da3e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a282da3e&scoped=true", function () {
      api.rerender('a282da3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/P5_Activitys/Liveness/index.vue"
export default component.exports